import React,{useEffect} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { ToastContainer,toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';

const CorpProfilemain = () => {

   /*----Local storage for display the username in navbar----*/

  useEffect(()=>{

    document.getElementById("name").innerHTML=localStorage.getItem('username')
    document.getElementById("email").innerHTML=localStorage.getItem('email')
   
    });


    // -----Validation-----//


  function handleSubmit(event){
    event.preventDefault()


    var Current = document.getElementById("Current1").value;
    
    var New = document.getElementById("New1").value;
    const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 

    var Confirm = document.getElementById("Confirm1").value;


    
    if(!Current){
      document.getElementById('CurrentErr').innerHTML="Enter Current Password";
    }
    
    else{
      
      document.getElementById('CurrentErr').innerHTML=" ";
    }


    if(!New){
      document.getElementById('NewErr').innerHTML="Enter New Password";
      document.getElementById('NewErrB').innerHTML=" ";
    }
   else if (password1.test(document.getElementById('New1').value)===false){
    document.getElementById('NewErrA').innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
   }
   else if (New==Current){
    document.getElementById('NewErrB').innerHTML="Don't repeat Your Current Password,Try New Password";
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";
   }
   else{
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";
    
   }

   if(!Confirm){
    document.getElementById('ConfirmErr').innerHTML="Re-enter Password";
   }
   else if(Confirm != New){
    document.getElementById('ConfirmErrA').innerHTML="Password doesn't Match";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
   else{
    document.getElementById('ConfirmErrA').innerHTML=" ";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
    
   if(Current&&(password1.test(document.getElementById('New1').value)===true)&&(Confirm == New)&&(New!=Current))
   {
        //change password//

        const body ={currentPassword: Current, newPassword:New}
        let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
      
        axios({
               method: "POST",
               url :`${BASE_URL}/Authenticate/ChangePassword`,
               data: body, 
               headers: {
                    "Content-Type": "application/json",
                    'Authorization':bearer 
                }     
            }) 
        
      .then((response) =>{
        console.log(response.data);
      
      
       if(response.data.status === "Error"){
           
            alert("InCorrect Password")
          }
      
          else if(response.data.status === "Success"){
            alert("Password Change Successfully!")
      
            // toast.success("Password Change Successfully!", {
            //   position: "top-center",
            //   autoClose: 3200,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   className: 'toast-message'
            //   });
              setTimeout(() => {
                
                window.location.href="/#/"
              }, 5000);
           
           
      
          }
        })
        .catch(error => {
          console.log(error);
        //  alert("failed !")
        toast.error('Incorrect Password')
         
        })
          
      
         
         
       
      }
      } 

     //Validation//

  function handlechange(event){
    event.preventDefault()


    var Current = document.getElementById("Current1").value;
    
    var New = document.getElementById("New1").value;
    const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 

    var Confirm = document.getElementById("Confirm1").value;


    
    if(!Current){
      document.getElementById('CurrentErr').innerHTML="Enter Current Password";
     
    }
   
    else{
      
      document.getElementById('CurrentErr').innerHTML=" ";
    }


    if(!New){
      document.getElementById('NewErr').innerHTML="Enter New Password";
      document.getElementById('NewErrA').innerHTML=" ";
      document.getElementById('NewErrB').innerHTML=" ";

    }
   else if (password1.test(document.getElementById('New1').value)===false){
    document.getElementById('NewErrA').innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
   }
   else if (New==Current){
    document.getElementById('NewErrB').innerHTML="Don't repeat Your Current Password, Try New Password";
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";
   }
   else{
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
   }

   if(!Confirm){
    document.getElementById('ConfirmErr').innerHTML="Re-enter Password";
    document.getElementById('ConfirmErrA').innerHTML=" ";
   }
   else if(Confirm != New){
    document.getElementById('ConfirmErrA').innerHTML="Password doesn't Match";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
   else{
    document.getElementById('ConfirmErrA').innerHTML=" ";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
    
   
  }



   
  


 /*----Function open form----*/

 function Changeformopen(event){
  event.preventDefault()
 

 {

    document.getElementById("modalRegisterForm").style.display = "block";

  }
}
  

/*----Function close form----*/

  function Changeformclose()

  {

    document.getElementById("CurrentErr").innerHTML=" ";

   

    document.getElementById("NewErr").innerHTML="  ";  

    document.getElementById("NewErrA").innerHTML="  ";  

    document.getElementById("ConfirmErr").innerHTML="  ";  

    document.getElementById("ConfirmErrA").innerHTML="  ";

    



    document.getElementById("Corpform").reset();

     document.getElementById("modalRegisterForm").style.display = "none";

   }

   /*----Password Function----*/



   function Corphide1(){

         

    var x = document.getElementById("Current1");

    var eye = document.getElementById("eye4");



    if(x.type === "password"){



      x.type = "text";

      eye.classList.remove("fa-eye-slash")

      eye.classList.add("fa-eye")

     

    }

    else{

      x.type = "password";

      eye.classList.remove("fa-eye")

      eye.classList.add("fa-eye-slash")

    }



   }

   function Corphide2(){

         

    var x = document.getElementById("New1");

    var eye = document.getElementById("eye5");



    if(x.type === "password"){



      x.type = "text";

      eye.classList.remove("fa-eye-slash")

      eye.classList.add("fa-eye")

     

    }

    else{

      x.type = "password";

      eye.classList.remove("fa-eye")

      eye.classList.add("fa-eye-slash")

    }



   }


   function Corphide3(){

         

    var x = document.getElementById("Confirm1");

    var eye = document.getElementById("eye6");



    if(x.type === "password"){



      x.type = "text";

      eye.classList.remove("fa-eye-slash")

      eye.classList.add("fa-eye")

     

    }

    else{

      x.type = "password";

      eye.classList.remove("fa-eye")

      eye.classList.add("fa-eye-slash")

    }



   }
   
   


  return (

    <>
    <div className='Corp-addmain'>

     {/*  Toastify */ }

     <ToastContainer id="toast"

position="top-center"

autoClose={1500}

hideProgressBar={false}

newestOnTop={false}

closeOnClick

rtl={false}

pauseOnFocusLoss

draggable

pauseOnHover

/>

    <div className="Corp-addgrid-layout">
    <div className="Corp-addmain-top">
        <div className='Corp-addmain-back'>
           <Link to='/Kdp Corp'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>Welcome to Your Profile</span>
 

     </div>
 </div>
 
 <div>
       <div className="modal-dialog" role="document">
          <div className="modal-content">

            {/* <div className="modal-header text-center">
                <h4 className="modal-title w-100 font-weight-bold">ADD USER</h4>
       
                <span aria-hidden="true">&times;</span>
              
            </div> */}


      
            <form >

              <div className="modal-body mx-3">

              <div className="md-form mb-5">
              </div>

                  <div className="md-form mb-5">
         
                     <span type="text" className="form-control validate"   id="name" readOnly/>
        
                  </div>

                  <div className="md-form mb-5">
          
                      <span type="email"  className="form-control validate"  id="email" readOnly />
         
                  </div>

                  
                </div>
      
                  <div className="modal-footer d-flex justify-content-center">
                        <button className="Corp-profile-button" onClick={Changeformopen} >Change Password</button>
                  </div>

           </form>



          </div>
     </div>
</div>



<div className="Corp-profile-fade" id="modalRegisterForm" tabindex="-1" role="dialog"
  aria-hidden="true">
       <div className="modal-dialog" role="document"  id="Corpcenterform">
          <div className="modal-content">

            <div className="modal-header text-center">
                <h4 className="modal-title w-100 font-weight-bold">CHANGE PASSWORD</h4>
                <button type="button" className="close" onClick={Changeformclose}>
                <span aria-hidden="true">&times;</span>
                </button>
            </div>


      
            <form onSubmit={handleSubmit} id="Corpform">
              <div className="modal-body mx-3">
                  <div className="md-form mb-5">
                  <div style={{display:"flex"}}>
                     <input type="Password" className="form-control validate" onKeyUp={handlechange} placeholder='Current Password' id="Current1"/>
                     <span className='eyeicon4'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={Corphide1} id="eye4"></i></span>
                     </div>
                     <span  className='error' id="CurrentErr"></span>
                   
        
                  </div>

                  <div className="md-form mb-5">
                  <div style={{display:"flex"}}>
                      <input type="Password"  className="form-control validate"onKeyUp={handlechange} placeholder='New Password' id="New1" />
                      <span className='eyeicon5'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={Corphide2} id="eye5"></i></span>
                      </div>
                      
                      <span className='error' id="NewErr"></span>
                     <span className='error' id="NewErrA"></span>
                     <span className='error' id="NewErrB"></span>
         
                  </div>

                  <div className="md-form mb-5">
                  <div style={{display:"flex"}}>
                      <input type="Password" className="form-control validate" onKeyUp={handlechange}  placeholder='Confirm Password'  id="Confirm1"/>
                      <span className='eyeicon6'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={Corphide3} id="eye6"></i></span>
                      </div>
                      <span className='error' id="ConfirmErr"></span>
                     <span  className='error' id="ConfirmErrA"></span>
         
                  </div>
                        

                </div>
      
                  <div className="modal-footer d-flex justify-content-center">
                        <button className="Corp-adduser-button" >Submit</button>
                  </div>

             </form>



          </div>
     </div>
</div>

 
 </div>
 </>
   
  )
}

export default CorpProfilemain
